import { handleCountryCodes } from './HandleCountryCodes.js'

const validateRow = (data) => {
    let valid = true
    let columns = []

    if (data) {
        // eslint-disable-next-line
        const emailRegex = /^\b(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
        const phoneRegex = /^(\+0?1\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
        if (data.email && !emailRegex.test(data.email.toLowerCase())) { valid = false; columns.push('email') }
        if (data.phone && !phoneRegex.test(handleCountryCodes(data.phone))) { valid = false; columns.push('phone') }
        if (!data.fName) { valid = false; columns.push('fName') }
        if (!data.lName) { valid = false; columns.push('lName') }
    }
    return ({ valid, columns }) //returns error fields and if the row is valid
}

export default validateRow